/**
 after a set number of characters, truncate the contents of a container and replace with a prompt to 'Read More' (this
 string is a configurable parameter)
 **/
const ReadMoreModel = Backbone.Model.extend({
    defaults: {
        maxChars: null,
        overflowChars: null,
        promptText: null,

        allText: null,
        shownText: null
    },

    isShowingAllText() {
        return this.get('allText') === this.get('shownText');
    },

    truncatedText() {
        return this.get('allText').substr(0, this.get('maxChars'));
    }
});

const ReadMoreView = Backbone.View.extend({
    template: _.template("<p><%= text %><% if (showReadMore) { %><%= overflowChars %><span class='read-more-btn'><%= promptText %></span><% } %></p>"),

    events: {
        'click .read-more-btn': 'loadAllText'
    },

    initialize() {
        this.model.on('change:shownText', this.render, this);
        this.model.set({shownText: this.model.truncatedText()})
    },

    loadAllText() {
        this.model.set({shownText: this.model.get('allText')});
    },

    render() {
        this.$el.html(this.template({
            showReadMore: !this.model.isShowingAllText(),
            overflowChars: this.model.get('overflowChars'),
            promptText: this.model.get('promptText'),
            text: this.model.get('shownText')
        }));
    }
});


let createReadMore = (textEl, options) => {
    let defaults = {
        promptText: "Read More",
        maxChars: 60,
        overflowChars: "..."
    };

    options = $.extend({}, defaults, options);

    let readMoreModel = new ReadMoreModel({
        maxChars: options.maxChars,
        overflowChars: options.overflowChars,
        promptText: options.promptText,
        allText: $(textEl).text()
    });

    new ReadMoreView({
        model: readMoreModel,
        el: textEl
    });
};


module.exports = createReadMore;


// WEBPACK FOOTER //
// ./assets/js/app/lib/read-more.js